
import { createContext, useState } from "react";
import { addNewClient, handleLoginClient, handleSignIn } from "../firebase/firebase_functions";

export const SignContext = createContext(null);

// =====================
// Sign context provider
// =====================
export default function SignContextProvider({children}){
    
    // Main
    const problemOptions = {
        passwordNotMatch:"הסיסמא לא תואמת",
        invalidPass:"סיסמא לא תקינה",
        invalidEmail:"אימייל לא תקין - אנא בדוק את האימייל שהזנת",
        invalidPhone:"מס' פלאפון לא תקין",
        invalidName:"שם לא תקין - אותיות בעברית/אנגלית בלבד (בין 2-35 תווים ורווח אחד)",
        fillAllFields:"יש למלא את כל השדות!",
        userNotFound:"משתמש לא נמצא - אנא בדוק שהזנת פרטי התחברות נכונים",
        somethingWentWrong:"משהו השתבש, אנא נסה שנית מאוחר יותר",
        loginManager:"החיבור בוצע בהצלחה - הינך מועבר לדשבורד הניהול",
    };
    
    // Login
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPass, setLoginPass] = useState("");
    const [loginFlag, setLoginFlag] = useState(false);

    // Signup
    const [signupName, setSignupName] = useState("");
    const [signupEmail, setSignupEmail] = useState("");
    const [signupPass, setSignupPass] = useState("");
    const [signupRePass, setSignupRePass] = useState("");
    const [signupPhone, setSignupPhone] = useState("");
    const [signupFlag, setSignupFlag] = useState(false);
    
    // Signin
    const [signinEmail, setSigninEmail] = useState("");
    const [signinPass, setSigninPass] = useState("");
    const [signinFlag, setSigninFlag] = useState(false);


    // =============
    // Manager login
    // =============
    // Handle manager login
    const login=async( nav, setCurrentWebsite, setConnectedManager, setCategoryNow, setCurrentManager, setCurrentManagerUID, setToastMessage, messagesOptions)=>{

        setLoginFlag(true);
        try{
            // Attempt to sign in at firebase auth
            const res = await handleSignIn(loginEmail, loginPass, setCurrentManager, setCurrentManagerUID, setToastMessage, messagesOptions);
            await new Promise(resolve => setTimeout(resolve, 750));
            // If it's a regular manager => move to relevant dashboard
            if(res?.user){
                const domain = res?.data?.settings?.domain;
                const owner = res?.data?.owner;
                setToastMessage(problemOptions.loginManager);
                await new Promise(resolve => setTimeout(resolve, 1000));
                setCurrentWebsite(res?.data);
                setCategoryNow(res?.data?.settings?.categories[0]);
                setConnectedManager(true);
                window.scrollTo({
                    top:0,
                    'behavior':'smooth'
                });
                nav(`/${domain}/${owner.uid}/dashboard`);
            }
            // Else if it's an admin => move to specific admin dashboard tool
            else if(res?.admin){
                setConnectedManager(true);
                window.scrollTo({
                    top:0,
                    behavior:"smooth"
                });
                await new Promise(resolve => setTimeout(resolve, 500));
                const adminUID = localStorage.getItem("webingo_currentManagerUID");
                nav(`/webingo/admin_${JSON.parse(adminUID)}/dashboard`);
            }
            // Any error got on attempt to sign in => toast relevant error
            else if(res?.err){
                setToastMessage(res.err);
                return;
            }
            else{
                return;
            }
        }
        catch(error){
            console.error("Error on login: \n"+error);
            setToastMessage(problemOptions.somethingWentWrong);
            return;
        } finally{
            setLoginFlag(false);
        }
    }

    // ======================
    // Client sign in/sign up
    // ======================
    // Client sign up validation
    const validateSignup=(phone, name, email, pass, repass, setToastMessage)=>{
        if(!phone || !name || !email || !pass || !repass || phone === "" || name === "" || email === "" || pass === "" || repass === ""){
            setToastMessage(problemOptions.fillAllFields);
            return false;
        }
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const regexName = /^(?:[A-Za-z]{1,17} [A-Za-z]{1,17}|[א-ת]{1,17} [א-ת]{1,17})$/;
        // const regexPass = /^(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,36}$/;
        const regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,36}$/;
        const regexPhone = /^0\d{8,9}$/;
        if(!name.match(regexName)){
            setToastMessage(problemOptions.invalidName);
            return false;
        }
        if(!phone.match(regexPhone)){
            setToastMessage(problemOptions.invalidPhone);
            return false;
        }
        if(!email.match(regexEmail)){
            setToastMessage(problemOptions.invalidEmail);
            return false;
        }
        if(!pass.match(regexPass)){
            setToastMessage(problemOptions.invalidPass);
            return false;    
        }
        if(pass !== repass || !repass.match(regexPass)){
            setToastMessage(problemOptions.passwordNotMatch);
            return false;
        }
        return true;
    }
    // Client sign up => adding new user to current website
    const addUser=async(website, nav, setToastMessage)=>{
        if(!website){
            setToastMessage(problemOptions.somethingWentWrong);
            return;
        };
        setSignupFlag(true);
        // Check validation of inputs
        const isValid = validateSignup(signupPhone, signupName, signupEmail, signupPass, signupRePass, setToastMessage);
        if(!isValid){
            setSignupFlag(false);
            return;
        };
        // If valid => create new client to website's clients array
        try{
            const newUser ={
                _id: Date.now(),
                createdAt: new Date(),
                name:signupName.toLowerCase().trim(),
                email:signupEmail.trim(),
                pass:signupPass,
                address:"",
                paymentMethod:{
                    cardNum:null,
                    expDate:null,
                    cvv:null,
                },
                phone: signupPhone.trim(),
                orders:[]
            }
            const res = await addNewClient(website.id, newUser);
            // Adding new client succeeded => set toast "welcome" and move to sign in page
            if(res){
                setToastMessage(`ברוכים הבאים!\nאנחנו שמחים שבחרת להצטרף אלינו - ${website?.settings?.website_name}\nכעת כל שעליך לעשות הוא להתחבר ותוכל להתחיל`);
                await new Promise(resolve => setTimeout(resolve, 2000))
                window.scrollTo({
                    top:0,
                    behavior:"smooth"
                })
                nav(`/${website?.settings?.domain}/signin`);
                
            }
            else{
                setToastMessage(problemOptions.somethingWentWrong);
            }
        }
        catch(error){
            console.error("Error on adding new user: \n"+error);
            setToastMessage(problemOptions.somethingWentWrong);
            return;
        } finally{
            setSignupFlag(false);
        }
    }
    // Client sign in validation
    const validateSignin = (email, pass, setToastMessage)=>{
        if(!email || !pass || email === "" || pass === "" ){
            setToastMessage(problemOptions.fillAllFields);
            return false;
        }
        const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // const regexPass = /^(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,36}$/;
        const regexPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*]{8,36}$/;
        if(!email.match(regexEmail)){
            setToastMessage(problemOptions.invalidEmail);
            return false;
        }
        if(!pass.match(regexPass)){
            setToastMessage(problemOptions.invalidPass);
            return false;    
        }
        return true;
    }
    // Client sign in => search user which attempting to sign in, out of the current website
    const findUser = async(website, nav, setClient, setConnected, setCurrentUID, setToastMessage )=>{
        if(!website){
            setToastMessage(problemOptions.somethingWentWrong);
            return;
        };
        if(!signinEmail || !signinPass || signinEmail.length===0 || signinPass.length===0){
            setToastMessage(problemOptions.fillAllFields);
            return false;
        }
        setSigninFlag(true);
        // Check if inputs valid
        const isValid = validateSignin(signinEmail, signinPass, setToastMessage);
        if(!isValid){
            setSigninFlag(false);
            return;
        };
        // If valid => attempt to login client with credential given
        try{
            const userToFind = {
                email: signinEmail,
                pass: signinPass
            };
            const res = await handleLoginClient(website.id, userToFind);
            // Failed login => set toast message and return
            if(!res || res=== null || res === undefined){
                setToastMessage(problemOptions.userNotFound);
                return;
            }
            // Succeeded login => set states and move back to home page to start
            else{
                setClient(res);
                setConnected(true);
                setCurrentUID(res._id);
                nav(`/${website.settings.domain}/home`)
            }
        } catch(error){
            console.error("Error trying to find user: \n"+error);
            setToastMessage(problemOptions.somethingWentWrong);
        } finally{
            setSigninFlag(false);
        }
    }


    const val ={
        
        // Login:
        login,
        loginEmail,
        setLoginEmail,
        loginPass,
        setLoginPass,
        loginFlag,

        // Signup:
        signupEmail,
        setSignupEmail,
        signupPass,
        setSignupPass,
        signupPhone,
        setSignupPhone,
        signupRePass,
        setSignupRePass,
        signupName,
        setSignupName,
        signupFlag,
        addUser,

        // Signin:
        setSigninEmail,
        setSigninPass,
        signinFlag,
        findUser
    }
    return(
        <SignContext.Provider value={val}>
            {children}
        </SignContext.Provider>
    )
}